import { styled } from '../../base-components';

export const TableWrapper = styled('div')<{ maxHeight?: number }>(
    ({ maxHeight }) => ({
        maxHeight: maxHeight ? `${maxHeight}px` : '100%',
        maxWidth: '100%',
        overflow: 'hidden',
        borderRadius: '8px',
        display: 'block',
        position: 'relative',
    })
);

export const LoaderPlaceholder = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.common.white,
}));
